// extracted by mini-css-extract-plugin
module.exports = {"topics-page-container":"Topics_topics-page-container__3nrPj","group-topics-text":"Topics_group-topics-text__rJjt6","topics-list":"Topics_topics-list__1gZCa"};